import { render } from "./Assmenblies.vue?vue&type=template&id=4c3de120"
import script from "./Assmenblies.vue?vue&type=script&lang=js"
export * from "./Assmenblies.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__